var _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBerandaActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic:home-fill"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M20.75 19V10.5C20.75 10.3448 20.7139 10.1916 20.6444 10.0528C20.575 9.91393 20.4742 9.79315 20.35 9.7L13.35 4.45C13.1769 4.32018 12.9664 4.25 12.75 4.25C12.5336 4.25 12.3231 4.32018 12.15 4.45L5.15 9.7C5.0258 9.79315 4.925 9.91393 4.85557 10.0528C4.78614 10.1916 4.75 10.3448 4.75 10.5V19C4.75 19.2652 4.85536 19.5196 5.04289 19.7071C5.23043 19.8946 5.48478 20 5.75 20H9.75C10.0152 20 10.2696 19.8946 10.4571 19.7071C10.6446 19.5196 10.75 19.2652 10.75 19V16C10.75 15.7348 10.8554 15.4804 11.0429 15.2929C11.2304 15.1054 11.4848 15 11.75 15H13.75C14.0152 15 14.2696 15.1054 14.4571 15.2929C14.6446 15.4804 14.75 15.7348 14.75 16V19C14.75 19.2652 14.8554 19.5196 15.0429 19.7071C15.2304 19.8946 15.4848 20 15.75 20H19.75C20.0152 20 20.2696 19.8946 20.4571 19.7071C20.6446 19.5196 20.75 19.2652 20.75 19Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBerandaActive);
export default __webpack_public_path__ + "static/media/beranda_active.a82f60343efc9206f9e36ef908454a84.svg";
export { ForwardRef as ReactComponent };